<script setup lang="ts">
defineProps<{ title: string; optional?: boolean }>()
</script>

<template>
  <div class="border-border space-y-4 rounded-lg border p-4">
    <p class="text-muted-foreground text-xs font-medium uppercase tracking-wide">
      {{ title }}<span v-if="optional" class="normal-case"> (optional)</span>
    </p>
    <slot />
  </div>
</template>
